import React from 'react';
import PropTypes from 'prop-types';
import {
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  FormLabel,
  FormHelperText,
} from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledFormControlLabel = styled(FormControlLabel)({
  marginBottom: '-8px',
});

export default function StyledRadioInput(props) {
  const { errors, label, name, options, value, onChange } = props;
  const stringValue = value !== undefined ? value.toString() : '';

  // Handle changes and convert the value to its appropriate type
  const handleChange = (e) => {
    const newValue = e.target.value;

    // Determine the correct type based on the original option types
    const originalOption = options.find((option) => option.value.toString() === newValue);
    if (originalOption) {
      onChange(originalOption.value);
    } else {
      onChange(newValue);
    }
  };

  const handleClick = (e) => {
    // Trigger onChange if the same value is clicked again
    if (e.target.value === stringValue) {
      handleChange(e);
    }
  };

  return (
    <FormControl component="fieldset" error={!!errors}>
      {label && <FormLabel component="legend">{label}</FormLabel>}
      <RadioGroup name={name} value={stringValue} onChange={handleChange} row>
        {options.map((option) => (
          <StyledFormControlLabel
            key={option.value.toString()}
            value={option.value.toString()}
            control={<Radio />}
            label={option.label}
            onClick={(e) => handleClick(e)}
          />
        ))}
      </RadioGroup>
      {errors && <FormHelperText>{errors.message}</FormHelperText>}
    </FormControl>
  );
}

StyledRadioInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
    label: PropTypes.string.isRequired,
  })),
};
